import "magnific-popup";
import "./lib/turn.js";
import "./lib/jquery.mousewheel.min.js";
import Swiper from 'swiper/bundle';
import jScrollPane from 'jscrollpane';

jQuery(function ($) {

  // loading
  $(function () {
    setTimeout(function () {
      $('.loading').fadeIn(0);
    }, 0);
    setTimeout(function () {
      $('.loading').fadeOut(1700);
    }, 1700);
  });

  $('.value-list-item, .sample-list-item').magnificPopup({
    type:'inline',
  });

  $('.movie-list-item').magnificPopup({
    type:'iframe',
  });

  $(function () {
    if ($('.swiper1').length) {
      var mySwiper = new Swiper('.swiper1', {
        mode: 'horizontal',
        grabCursor: true,
        scrollContainer: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
            slidesOffsetAfter: 0,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
            slidesOffsetAfter: 0,
          }
        }
      });
    }

    if (matchMedia('(max-width: 767px)').matches) {
      var mySwiper2 = new Swiper('.swiper2', {
        mode: 'horizontal',
        freeMode: true,
        grabCursor: true,
        scrollContainer: true,
        width: '335',
        slidesPerView: 1,
        spaceBetween: 10,
        slidesOffsetAfter: 0,
        scrollbar: {
          el: '.swiper-scrollbar2',
          draggable: true,
        }
      });
    }
  });

  $(window).on('resize', function () {
    if (matchMedia('(min-width: 768px)').matches) {
      var windowWidth = window.innerWidth;
      var itemWidth = $('.movie-list-item').width();
      var itemStartPos = (windowWidth / 2) - (itemWidth / 2);
      $('.movie-wrap').offset({ left: itemStartPos });
    } else {
      $('.movie-wrap').offset({ left: 20 });
    }
  });

  //tab切り替え
  $(function () {
    $('.js-tab li').click(function () {
      var index = $('.js-tab li').index(this);
      $('.js-tab li').removeClass('is_active');
      $(this).addClass('is_active');
      $('.pickUp__tabBox').removeClass('is_show').eq(index).addClass('is_show');
    });
  });

  $(function () {
    var totalPages2 = $('.pickUp-manual-item').length;

    if ($('#pickUp-manual').length) {
      if (window.matchMedia('(max-width: 767px)').matches) {
        $('#pickUp-manual').turn({
          // 自動でページをめくったときの高さ
          elevation: 50,
          // ページめくりのスピード(ms)
          duration: 1000,
          // ページをめくるときの影->有効
          gradients: true,
          // 右開きか左開きかの設定->右開き
          direction: 'ltr',
          display: 'single',
          autoCenter: true,
        });
      } else {
        $('#pickUp-manual').turn({
          // 自動でページをめくったときの高さ
          elevation: 50,
          // ページめくりのスピード(ms)
          duration: 1000,
          // ページをめくるときの影->有効
          gradients: true,
          // 自動中央揃え->無効
          autoCenter: false,
          // 右開きか左開きかの設定->右開き
          direction: 'ltr',
        });
      }
      $('#prevpage').on('click', function(){
        $('#pickUp-manual').turn('previous');
      });
      $('#nextpage').on('click', function(){
        $('#pickUp-manual').turn('next');
      });
      $('#firstpage').on('click', function(){
        $('#pickUp-manual').turn('page', 1);
      });
      $('#lastpage').on('click', function () {
        $('#pickUp-manual').turn('page', totalPages2);
      });
    }

    var totalPages = $('.pickUp-text-item').length;

    if ($('#pickUp-text').length) {
      if (window.matchMedia('(max-width: 767px)').matches) {
        $('#pickUp-text').turn({
          // 自動でページをめくったときの高さ
          elevation: 50,
          // ページめくりのスピード(ms)
          duration: 1000,
          // ページをめくるときの影->有効
          gradients: true,
          // 右開きか左開きかの設定->右開き
          direction: 'ltr',
          display: 'single',
          autoCenter: true,
        });
      } else {
        $('#pickUp-text').turn({
          // 自動でページをめくったときの高さ
          elevation: 50,
          // ページめくりのスピード(ms)
          duration: 1000,
          // ページをめくるときの影->有効
          gradients: true,
          // 自動中央揃え->無効
          autoCenter: false,
          // 右開きか左開きかの設定->右開き
          direction: 'ltr',
        });
      }
      $('#prevpage2').on('click', function(){
        $('#pickUp-text').turn('previous');
      });
      $('#nextpage2').on('click', function(){
        $('#pickUp-text').turn('next');
      });
      $('#firstpage2').on('click', function(){
        $('#pickUp-text').turn('page', 1);
      });
      $('#lastpage2').on('click', function () {
        $('#pickUp-text').turn('page', totalPages);
      });
    }
  });

  $(function() {
    if ($('.usePrice-sidescroll-inner').length) {
      $('.usePrice-sidescroll-inner').jScrollPane({
        arrowScrollOnHover: true,
      });
    }
  });

});
